
import studioHomeOverviewTitleIconWhite from '@home/assets/svg/studio/home/overview-icon-white.svg';
import techlandBackCatalogueKpiTitleIcon from '@home/assets/svg/studio/home/techland_back_catalogue_kpi_title_icon.svg';
import techlandDl1KpiTitleIcon from '@home/assets/svg/studio/home/techland_dl1_kpi_title_icon.svg';
import techlandDl2KpiTitleIcon from '@home/assets/svg/studio/home/techland_dl2_kpi_title_icon.svg';
import techlandDltbKpiTitleIcon from '@home/assets/svg/studio/home/techland_dltb_kpi_title_icon.svg';
import techlandKpiTitleIcon from '@home/assets/svg/studio/home/techland_kpi_title_icon.svg';
import techlandSpecialDealsKpiTitleIcon from '@home/assets/svg/studio/home/techland_special_deals_kpi_title_icon.svg';


/** Techland Studio Home — card_metrics 等与接口相关的公共常量（PC） */

export const TECHLAND_CARD_METRICS_API =
  '/api/v2/dashboard/studio/overall/card_metrics';

/** Studio Techland 趋势曲线（与 card_metrics 同请求体结构，接口路径不同） */
export const TECHLAND_TREND_METRICS_API =
  '/api/v2/dashboard/studio/overall/trend_metrics';

export const TECHLAND_GAME_CODE = 'techland_overview';

export const TECHLAND_STUDIO_CODE = 'techland';

/** 筛选 scope：净收入 / 毛收入 */
export const TECHLAND_SCOPE_NET = 'net_revenue';
export const TECHLAND_SCOPE_GROSS = 'gross_revenue';

/** YTD 指标名（与后端 metrics 一致） */
export const METRIC_YTD_PROFIT = 'ytd_profit';

export const METRIC_YTD_GROSS_REVENUE = 'ytd_gross_revenue';

export const METRIC_YTD_BUDGET = 'ytd_budget';

export const METRIC_YTD_PLAN = 'ytd_plan';

/** TechlandYtdCardMetricsService 写入 data，供 TechlandYtdRevenueCardSlot 在加载态使用模板 */
export const TECHLAND_CARD_DISPLAY_TEMPLATE_DATA_KEY = 'techlandCardDisplayTemplate';


/**
 * 管理端可只配字面量 key；运行时换成本地打包后的 URL。
 * key 与文件名（无 .svg）一致，便于对照资产目录。
 */
export const STUDIO_KPI_TITLE_ICON_SRC_MAP: Record<string, string> = {
  /** Studio Home Overall 等 YTD 卡片标题 */
  studio_home_overview_title_icon_white: studioHomeOverviewTitleIconWhite,
  techland_back_catalogue_kpi_title_icon: techlandBackCatalogueKpiTitleIcon,
  techland_dl1_kpi_title_icon: techlandDl1KpiTitleIcon,
  techland_dl2_kpi_title_icon: techlandDl2KpiTitleIcon,
  techland_dltb_kpi_title_icon: techlandDltbKpiTitleIcon,
  techland_kpi_title_icon: techlandKpiTitleIcon,
  techland_special_deals_kpi_title_icon: techlandSpecialDealsKpiTitleIcon,
};

/** titleIconSrc 非空时直接用（远程链接等）；否则用 titleIconSrcKey 查表 */
export function resolveStudioKpiTitleIconSrc(opts: {
  titleIconSrc?: string;
  titleIconSrcKey?: string;
}): string | undefined {
  const { titleIconSrc, titleIconSrcKey } = opts || {};
  if (titleIconSrc !== undefined && titleIconSrc !== null && String(titleIconSrc).trim() !== '') {
    return titleIconSrc;
  }
  if (titleIconSrcKey && STUDIO_KPI_TITLE_ICON_SRC_MAP[titleIconSrcKey]) {
    return STUDIO_KPI_TITLE_ICON_SRC_MAP[titleIconSrcKey];
  }
  return undefined;
}

interface IGameListItem {
  game_code?: string;
  cover?: string;
}

/** 从 studioData.game_list 中按 game_code 匹配获取 cover 图片 URL */
export function resolveGameCoverFromGameList(
  studioData: { game_list?: IGameListItem[]; } | undefined | null,
  gameCode: string | undefined,
): string | undefined {
  if (!gameCode || !studioData?.game_list?.length) {
    return undefined;
  }
  const matched = studioData.game_list.find(
    (g) => g.game_code === gameCode,
  );
  return matched?.cover || undefined;
}
